module.exports = __webpack_public_path__ + "img/b97839825_350x350.d5839947.jpg";